<template>
    <div>
        <b-container class="dashboard p-t-10 p-b-20">
            <b-row class="p-t-10 p-b-20 p-l-15">
                <b-input-group>
                <month-picker-input style="z-index: 1; border-radius: 0"
                    @change="changeDate"
                    :input-pre-filled="true"
                    :default-year="currentYear"
                    :default-month="currentMonth"
                    :months="monthsBR"
                    >
                </month-picker-input>
                <b-input-group-append>
                    <b-button
                        v-b-tooltip.hover title="Download Relatório"
                        style="margin-left: 3px; margin-top: 0; border-color: lightgray"
                        variant="secundary"
                        @click="this.download"
                    >
                        <b-icon-download></b-icon-download>
                    </b-button>
                </b-input-group-append>
                </b-input-group>
            </b-row>
            <b-row>
                <template v-if="docsDailyLoaded">
                    <b-col>
                        <h4>Documentos Retornados</h4>
                        <div class="container" id="docsDailyProject">
                            <line-chart v-if="docsDailyLoaded"
                            :chartData="docsDailyData"
                            :options="docsDailyOptions"/>
                        </div>
                    </b-col>
                    <b-col>
                        <h4>Requisições Realizadas</h4>
                        <div class="container" id="reqsDailyProject">
                            <line-chart v-if="reqsDailyLoaded"
                            :chartData="reqsDailyData"
                            :options="reqsDailyOptions"/>
                        </div>
                    </b-col>
                    <b-col></b-col>
                </template>
                <template v-else>
                    <b-col></b-col>
                    <b-col class="no-data">
                        <h5 class="offmessage">Selecione um projeto para visualizar</h5>
                    </b-col>
                    <b-col></b-col>
                </template>
            </b-row>
        </b-container>
    </div>
</template>

<style scoped src="@/assets/css/util.css">
</style>

<style scoped>
    .offmessage {
        color: lightgray;
    }
</style>

<script>
    import axios from 'axios';
    import config from '../helpers/generalConfig';
    import { MonthPickerInput } from 'vue-month-picker';
    import LineChart from './LineChart.vue';
    import { BIconDownload } from 'bootstrap-vue';

    export default {
        components: { LineChart, MonthPickerInput, BIconDownload },

        data() {
            return {
                requisicoes_realizadas: '',
                nome_projeto_edit: '',
                monthsBR:['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho',
                 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                currentYear: new Date().getFullYear(),
                currentMonth: new Date().getMonth() + 1,
                date: null,
                docsDailyLoaded: null,
                docsDailyData: null,
                docsDailyOptions: null,
                reqsDailyLoaded: false,
                reqsDailyData: null,
                reqsDailyOptions: null,
            }
        },

        props: {
            companyId: {
                type: Number,
                default: 0
            },
            projectId: {
                type: Number,
                default: 0
            }
        },

        watch: {
            companyId: function () {
                this.getLogs(this.date)
            },
            projectId: function() {
                this.getLogs(this.date)
            }
        },

        mounted(){
            this.getLogs();
        },

        methods:{
             changeDate(date){
                this.date = date
                this.getLogs(date);
            },

            getLogs(date){
                const chosenPeriod = {month: null, year: null}
                if (date) {
                    chosenPeriod.month = date.monthIndex;
                    chosenPeriod.year = date.year;
                } else {
                    chosenPeriod.month = this.currentMonth;
                    chosenPeriod.year = this.currentYear;
                }

                var route = ''
                if(this.companyId && this.projectId){
                    route = `${config.jsonServer}/log/project/${chosenPeriod.year}/${chosenPeriod.month}/${this.projectId}`
                } else if (this.companyId){
                    route = `${config.jsonServer}/log/company/${chosenPeriod.year}/${chosenPeriod.month}/${this.companyId}`
                } else {
                    return
                }

                axios.get(route, this.headers())
                    .then( response => {
                        if(response.data == []) {
                            this.$bvToast.toast('Nenhum dado encontrado para este mês', {
                                    title: 'Dados de Logs Não Encontrados',
                                    variant: 'danger',
                                    solid: true
                                });
                            
                        } if(response.data) {
                            this.loadChartData(response.data)
                        }
                    })
                    .catch((err) => {
                            if(err.response){
                                this.$bvToast.toast(err.response.data.message, {
                                    title: 'Dados de Logs Não Encontrados',
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                        })
            },

            loadChartData(logs){
                let dates = []
                var docsData = []
                var reqsData = []
                for (let log of logs) {
                    if (!dates.includes(log.data)) {
                        dates.push(log.data)
                        docsData.push(log.documentos_retornados)
                        reqsData.push(1)
                    }
                    else {
                        docsData[dates.indexOf(log.data)] += log.documentos_retornados
                        reqsData[dates.indexOf(log.data)] += 1
                    }
                    
                }

                var labels = []
                for (let date of dates) {
                    labels.push(date.split('T')[0].split('-').reverse().join('/'))
                }
                
                labels = labels.map(function(data) {
                    data.split('T')[0].split('-').reverse().join('/')
                    return data
                })

                this.docsDailyData = {
                                labels: labels,
                                datasets: [{
                                    label: 'Documentos Retornados',
                                    data: docsData,
                                    fill: false,
                                    borderColor: '#861f1f',
                                    tension: 0.1
                                }]
                            }
                this.docsDailyLoaded = true
                
                this.reqsDailyData = {
                                labels: labels,
                                datasets: [{
                                    label: 'Requisições Realizadas',
                                    data: reqsData,
                                    fill: false,
                                    borderColor: '#861f1f',
                                    tension: 0.1
                                }]
                            }
                this.reqsDailyLoaded = true

            },

            headers() {
                const token = this.$store.getters['auth/token'].token
                const headers = { headers: { Authorization: 'Bearer ' + token }}
                return headers;
            },

            download() {
                if(!this.projectId && !this.companyId) {
                    this.$bvToast.toast('Selecione um projeto ou uma empresa para realizar o download', {
                        title: 'Projeto ou Empresa não selecionado',
                        variant: 'danger',
                        solid: true
                    });
                    return;
                }
                let ref, id;
                if (!this.projectId) {
                    ref = 'company';
                    id = this.companyId;
                } else {
                    ref = 'project';
                    id = this.projectId;
                }
                axios.get(
                    `${config.jsonServer}/log/report/${ref}/${this.currentYear}/${this.currentMonth}/${id}`,
                    { ...this.headers(), responseType: 'blob' }
                )
                    .then(response => {
                        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;' });
                        const link = document.createElement('a');
                        link.href = URL.createObjectURL(blob);
                        link.download = `report_${this.currentYear}_${this.currentMonth}_${id}.xlsx`;
                        link.click()
                        URL.revokeObjectURL(link.href)
                    }).catch((err) => {
                        console.log(err);
                        this.$bvToast.toast('Tente novamente dentro de alguns instantes, se o problema persistir contate um administrador.', {
                            title: 'Não foi possível realizar o download',
                            variant: 'danger',
                            solid: true
                        });
                    })
            }
        }

    }
</script>